import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Comment fonctionne GoBledPro ?",
    answer: "GoBledPro facilite la mise en relation entre clients et transporteurs indépendants. Vous déposez votre demande, nous identifions des transporteurs disponibles et vous mettons en contact. La transaction et le transport sont réalisés directement entre vous et le transporteur choisi."
  },
  {
    question: "Combien ça coûte ?",
    answer: "L'inscription est gratuite. Le prix du transport est fixé entre le client et le transporteur. GoBledPro peut facturer des frais de mise en relation. Vous recevez un devis clair de la part du transporteur avant de vous engager."
  },
  {
    question: "À quel moment je paie ?",
    answer: "Le paiement s'effectue directement auprès du transporteur, selon les modalités que vous convenez ensemble. GoBledPro peut percevoir des frais de mise en relation. Nous facilitons le contact, mais la transaction finale se fait entre vous et le transporteur."
  },
  {
    question: "Quels types de colis puis-je envoyer ?",
    answer: "Vous pouvez envoyer des colis, valises, documents et petits objets. Les produits dangereux, illégaux ou périssables ne sont pas acceptés. Chaque transporteur peut avoir des restrictions spécifiques selon son véhicule."
  },
  {
    question: "Comment sont vérifiés les transporteurs ?",
    answer: "Chaque transporteur passe par un processus de vérification structuré : contrôle d'identité, vérification des documents professionnels et validation de l'expérience. Les profils des transporteurs affichent leurs informations vérifiées."
  },
  {
    question: "Quels sont les délais de livraison ?",
    answer: "Les délais dépendent du transporteur, du trajet et des formalités douanières. GoBledPro ne garantit aucun délai. Chaque transporteur vous communique ses propres estimations lors de votre échange."
  },
  {
    question: "Mes colis sont-ils assurés ?",
    answer: "Les conditions d'assurance dépendent de chaque transporteur. Nous vous recommandons de discuter directement avec le transporteur choisi pour connaître les garanties proposées sur votre envoi."
  },
  {
    question: "Comment suivre mon colis ?",
    answer: "Une fois votre colis confié au transporteur, vous pouvez le contacter directement pour suivre l'avancement. Les modalités de suivi sont définies entre vous et le transporteur."
  },
  {
    question: "Comment devenir transporteur GoBledPro ?",
    answer: "Si vous effectuez régulièrement le trajet France-Maroc et souhaitez rentabiliser vos trajets, vous pouvez postuler via notre formulaire dédié. Après vérification de votre profil, vous pourrez recevoir des demandes de mise en relation."
  }
];

const FAQSection = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section 
      id="faq"
      ref={ref}
      className="py-12 md:py-20 bg-background"
    >
      <div className="container mx-auto px-4 max-w-4xl">
        <div 
          className="text-center mb-8 md:mb-12 transition-all duration-700"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(30px)'
          }}
        >
          <span className="inline-block px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-medium mb-4">
            FAQ
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3">
            Questions fréquentes
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Tout ce que vous devez savoir sur notre plateforme de mise en relation
          </p>
        </div>

        <div
          className="transition-all duration-700 delay-200"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(30px)'
          }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-card border border-border rounded-xl px-4 md:px-6 shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <AccordionTrigger className="text-left text-foreground hover:text-primary hover:no-underline py-4 text-sm md:text-base font-medium">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-4 text-sm md:text-base leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
